var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){$event.stopPropagation();}}},[(_vm.value)?_c('camera-screenshot',{attrs:{"refresh":"","screenshot":_vm.value,"width":160,"align":"center"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }